import api from './AxiosInstance';

export class TpecService {

    AddTauxpc = async (docData) => {
        try {
          const response = await api.post(`/TauxPC/applyTaux`, docData , 
          {
             
            }) 
          
          // Ajoutez une console.log pour afficher la réponse du serveur
          console.log('Réponse du serveur après l\'ajout de la facture :', response.data);
    
          return response.data;
        } catch (error) {
          console.error('Erreur lors de l\'ajout de la facture :', error);
          // Assurez-vous que la promesse est rejetée pour propager l'erreur
          throw error;
        }
      };
    
    updateTpec= async ( updatedPrestation) => {
        try {
         
    
          const response = await api.put(`/TauxPC/IPM/Update`, updatedPrestation)
    
          return response.data;
        } catch (error) {
          console.error('Erreur lors de la mise à jour de prestation :', error);
          throw error;
        }
      };
      deleteTpec = async (numligne) => {
        try {
          const response = await api.delete(`/TauxPC/IPM/${numligne}`);
          return response.data;
        } catch (error) {
          console.error('Erreur lors de la récupération des données :', error);
        
        }
      };
}


